export default __webpack_public_path__ + "static/media/bannerTablet.2e227954.jpg";